import Unauthorized from '../components/MessagePages/Unauthorized';
import PageLayout from '../components/pageLayout';

function UnauthorizedPage() {
  return <PageLayout children={<Unauthorized />} />;
}

export default UnauthorizedPage;
